module.exports = __webpack_public_path__ + "img/rate.c8abdb19.png";